import env from "../utils/env";
import { getLocalStorage } from "../utils/localStorageClient";

const baseUrl = env.backendBaseUrl;

const apiAssistant = (): Promise<Response> => {
  const accessId = JSON.parse(getLocalStorage("accessId") ?? "null");
  console.log("apiAssistant.accessId", accessId);
  const token = JSON.parse(getLocalStorage(`token/${accessId}`) ?? "null");
  console.log("apiAssistant.token", token);
  return fetch(baseUrl + "/api/apps/Assistant/Assistant", {
    method: "GET",
    headers: {
      ["Content-Type"]: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const apiMessages = (sessionId: string) => {
  const accessId = JSON.parse(getLocalStorage("accessId") ?? "null");
  console.log("apiAssistant.accessId", accessId);
  const token = JSON.parse(getLocalStorage(`token/${accessId}`) ?? "null");
  console.log("apiAssistant.token", token);
  return fetch(
    baseUrl + "/api/apps/Assistant/Messages?sessionId=" + sessionId,
    {
      method: "GET",
      headers: {
        ["Content-Type"]: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const apiFontSize = (fontSize: number) => {
  const accessId = JSON.parse(getLocalStorage("accessId") ?? "null");
  console.log("apiAssistant.accessId", accessId);
  const token = JSON.parse(getLocalStorage(`token/${accessId}`) ?? "null");
  console.log("apiAssistant.token", token);
  return fetch(baseUrl + "/api/apps/Assistant/FontSize", {
    method: "PUT",
    headers: {
      ["Content-Type"]: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      fontSize,
    }),
  });
};

export { apiAssistant, apiMessages, apiFontSize };
